import React, {
    useState,
    useEffect,
    useRef
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    // Image,
    Navbar,
    Nav,
    OverlayTrigger,
    Tooltip,
    Popover,
} from "react-bootstrap";
import { getFromLS, setToLS } from "../../../../utils/storage";
import * as Icon from "react-bootstrap-icons";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "./kone.css"
import { Bars } from "react-loader-spinner";
import { BlankPage } from "./BlankPage";
import { FieldPage } from "./FieldPage";
import { ApproveModal } from "./ApproveModal";
import { makeCygnusApiCall } from "../../../../api/api";
import { LEGEND_DATA } from "./constants";
import { CustomButton } from "../../../../reusable-components/CustomButtonComponent/button";
import { Document, Page } from 'react-pdf';

import "./ComparisonModal.css";

import { v4 } from "uuid";
import { CustomToaster } from "../../../../reusable-components/Toasters/toaster";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


export const ComparisonPDFViewer = ({ activePdfPageUrl, activePage, onDocumentLoad }) => {
    const containerRef = useRef(null);
    const [containerDimensions, setContainerDimensions] = useState({ width: 0, height: 0 });
    const token = getFromLS("token")
    
    const onDocumentLoadSuccess = ({ numPages }) => {
        if (onDocumentLoad) {
            requestAnimationFrame(() => {
                onDocumentLoad();
            });
        }
    };

    const onPageRenderSuccess = () => {
        if (onDocumentLoad) {
            requestAnimationFrame(() => {
                onDocumentLoad();
            });
        }
    };

    useEffect(() => {
        const updateDimensions = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setContainerDimensions({ width: clientWidth, height: clientHeight });
            }
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    const getPageWidth = () => {
        if (!containerDimensions.width) {
            return 400;
        }
        return containerDimensions.width;
    };

    return (
        <div
            ref={containerRef}
            className="pdf-wrapper"
            style={{
                flex: 1,
                overflow: 'auto',
                height: "100%",
                width: "100%",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor: '#f5f5f5',
            }}
        >
            <Document
                file={activePdfPageUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                options={{
                    httpHeaders: { Authorization: `Bearer ${token}`},
                }}
            >
                <Page
                    pageNumber={activePage || 1}
                    width={getPageWidth()}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    onRenderSuccess={onPageRenderSuccess}
                />
            </Document>
        </div>
    );
};

export const ComparisonModal = ({ onHide, ...props }) => {
    // console.log("COMPARISON FULL MODAL: ", props)
    const token = getFromLS("token");
    const [comparisonData, setComparisonData] = useState([]);
    const [file, setFile] = useState("");
    const [formResponseDataId, setFormResponseDataId] = useState();
    const [pageFileLink, setPageFileLink] = useState("");
    const [templateCache, setTemplateCache] = useState({});
    const [allKonesData, setAllKonesData] = useState([]);
    const [activeKoneIndex, setActiveKoneIndex] = useState();
    const [metaData, setMetaData] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [inputPage, setInputPage] = useState(activePage);
    const [templateUrls, setTemplateUrls] = useState({ "Page 1": "" });
    const [activePdfPageUrl, setActivePdfPageUrl] = useState("./TEMPLATE.pdf");
    const [k1TotalPages, setK1TotalPages] = useState(0);
    const [allKoneFields, setAllKoneFields] = useState({});
    const [PAGE_FIELD_MAPPER, setPageFieldMapper] = useState({});
    // APPROVAL RELATED
    const [approveModal, setApproveModal] = useState(false);
    const [saveApiResponse, setSaveApiResponse] = useState();
    const [validationApiResponse, setValidationApiResponse] = useState();
    const [approveApiResponse, setApproveApiResponse] = useState();
    const [draftUpdateApiProgress, setDraftUpdateApiProgress] = useState()
    const [validationStatus, setValidationStatus] = useState();
    const [validationErrorFields, setValidationErrorFields] = useState();
    const [validationIssues, setValidationIssues] = useState();
    const [previewCache, setPreviewCache] = useState({ "Page 1": <div className="preview-image" /> });
    const extractedCopyRef = useRef(null);
    const [showFields, setShowFields] = useState(false);
    const [onDocumentLoad, setOnDocumentLoad] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(true);
    let currentPage = "Page 1";

    const [dimensions, setDimensions] = useState({
        width: 0.065 * window.innerWidth,
        height: 0.178 * window.innerHeight,
    });

    const [sectionDimensions, setSectionDimensions] = useState({});

    const [activeKone, setActiveKone] = useState(
        {
            "FormResponseDataId": undefined,
            "FirmId": "",
            "FileName": {
                "type": "button",
                "placeholder": "",
                "url": ""
            },
            "Status": "",
            "OriginalFileName": "",
            "OCRProgress": "",
            "PartnerName": "",
            "FormYear": "",
            "NumberOfPages": ''
        }
    );
    const [activeKoneData, setActiveKoneData] = useState(
        {
            "FileName": { "url": "./TEMPLATE.pdf" },
            "TemplateUrls": "./tempk1.png",
            "FinalEngine": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "Metadata": {
                "Page 1": {
                    "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 2": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 3": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 4": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 5": { "Checkbox Coordinates": {}, "Text Coordinates": {} }
                }
            },
            "K1TemplateIds": [],
        });

    /** 
     * Capturing change in coomparison data dn updating state on change 
     * */
    useEffect(() => {
        setComparisonData(props.comparisondata)
        console.log(props.comparisondata)
    }, [props.comparisondata])

    /**
     * Based on updated comparison data set active K-1, all K-1 data, total pages, field map, preview cache
     */
    useEffect(() => {
        if (comparisonData.activekone !== undefined) {
            setActiveKone(comparisonData.activekone)
            
            setFile(comparisonData.activekone["FileName"]["url"])
            setPageFileLink(`${process.env.REACT_APP_TAX_URI}/tax/download/${comparisonData.activekone["DocumentId"]}/`)
            setActivePdfPageUrl(`${process.env.REACT_APP_TAX_URI}/tax/download/${comparisonData.activekone["DocumentId"]}/1/`)

            setAllKonesData(comparisonData.apidata)
            setK1TotalPages(comparisonData.activekone.NumberOfPages)
            
            // Simplified preview cache without individual loaders
            const preview = {}
            for (let i = 1; i < comparisonData.activekone.NumberOfPages + 1; i++) {
                Object.assign(preview, {
                    [`Page ${i}`]: <div className="preview-image" />
                })
            }
            setPreviewCache(preview)
        }
    }, [comparisonData])

    /**
     * Based on the selected K-1 update the File, Id, Link, PDF Url
     */
    useEffect(() => {
        if (activeKone !== undefined && activeKone.DocumentId !== undefined) {
            setFormResponseDataId(activeKone.DocumentId)
            if (activeKoneIndex === undefined) {
                setActiveKoneIndex(allKonesData.indexOf(activeKone))
            }
            console.log("ACTIVE KONE: ", activeKone)
            removeCachedPages()
        }
        setActivePage(1)
        setInputPage(1)
        setIsPageLoading(true) // Reset loading state when kone changes
        setOnDocumentLoad(false) // Reset document load state
    }, [activeKone])

    /**
     * Whenever the File ID is changes fetch the K-1 data for the selected file
     */
    useEffect(() => {
        if (formResponseDataId !== undefined) {
            getActiveKoneData(formResponseDataId)
        }
    }, [formResponseDataId])

    /**
     * Update the active konme based on updated index
     */
    useEffect(() => {
        if (activeKoneIndex !== undefined) {
            // console.log("ACTIVE KONE INDEX: ", activeKoneIndex)
            setActiveKone(comparisonData.apidata[activeKoneIndex])
        }
    }, [activeKoneIndex])


    useEffect(() => {
        if (activeKoneData !== undefined) {
            setTemplateUrls(activeKoneData["TemplateUrls"])
            if (Object.keys(activeKoneData["Metadata"]).length > 0) {
                const pageFieldMapper = {}
                const finalenginedata = {}
                Object.assign(finalenginedata, activeKoneData["FinalEngine"])
                setAllKoneFields(finalenginedata)
                
                console.log(activeKoneData["Metadata"])
                for (let [page, data] of Object.entries(activeKoneData["Metadata"])) {
                    if (Object.keys(data).length > 0) {
                        if (Object.keys(data["Page 1"]["Text Coordinates"]).length > 0) {
                            setMetaData(data)
                            Object.assign(pageFieldMapper, {
                                [page]:
                                    <FieldPage
                                        key={v4()}
                                        metadata={data}
                                        finalenginedata={finalenginedata[page]}
                                        filelink={pageFileLink}
                                        page={page}
                                        setactivepage={(page) => setActivePage(page)}
                                        updatefields={(page, id, map) => updateFields(page, id, map)}
                                        sectionDimensions={sectionDimensions}
                                    />
                            })
                        } else {
                            setMetaData(data)
                            Object.assign(pageFieldMapper, {
                                [page]:
                                    <BlankPage key={v4()} />
                            })
                        }
                    } else {
                    }
                    setPageFieldMapper(pageFieldMapper);
                    // console.log("PAGE FIELD MAPPER: ", PAGE_FIELD_MAPPER);
                }
            }
        }
    }, [activeKoneData, sectionDimensions]);

    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: 0.065 * window.innerWidth,
                height: 0.178 * window.innerHeight,
            });

            if (extractedCopyRef.current)
                setSectionDimensions(extractedCopyRef.current.getBoundingClientRect());
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
    if (onDocumentLoad && Object.keys(templateUrls).length > 0 && Object.keys(metaData).length > 0) {
        // Debounce the dimension calculation
        const debounceTimer = setTimeout(() => {
            if (extractedCopyRef.current) {
                const rect = extractedCopyRef.current.getBoundingClientRect();
                if (rect.width > 0 && rect.height > 0) {
                    setSectionDimensions(rect);
                    console.log('Setting dimensions:', rect);
                } else {
                    requestAnimationFrame(() => {
                        const retryRect = extractedCopyRef.current?.getBoundingClientRect();
                        if (retryRect?.width > 0 && retryRect?.height > 0) {
                            setSectionDimensions(retryRect);
                            console.log('Retry setting dimensions:', retryRect);
                        }
                    });
                }
            }
        }, 100); // Debounce by 100ms

        const hideLoaderTimer = setTimeout(() => {
            setIsPageLoading(false);
        }, 500);

        return () => {
            clearTimeout(debounceTimer);
            clearTimeout(hideLoaderTimer);
        };
    }
}, [onDocumentLoad, activePage, templateUrls, metaData]);

    useEffect(() => {
        const handlePreviewImageClick = (page) => {
            if (currentPage !== page) {
                currentPage = page;
                setShowFields(false);
            }
        };

        if (onDocumentLoad && Object.keys(templateUrls).length > 0) {
            const temp = {};
            const preview = {};

            // Function to render preview image
            const renderPreviewImage = (page, template, overlayText, onClickHandler = null) => (
                <div className="preview-image" onClick={onClickHandler ? () => onClickHandler(page) : undefined}>
                    <img
                        src={template === "./tempk1.png" ? require("./tempk1.png") : template}
                        style={{
                            width: dimensions.width,
                            height: dimensions.height,
                            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25)",
                            position: "relative",
                            borderRadius: 5
                        }}
                    />
                    {overlayText && <div className="preview-overlay">{overlayText}</div>}
                </div>
            );

            for (let [page, template] of Object.entries(templateUrls)) {
                temp[page] = (
                    <img
                        src={template === "./tempk1.png" ? require("./tempk1.png") : template}
                        style={{
                            width: "100%",
                            height: "100%",
                            boxShadow: "2px 4px 8px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    />
                );

                const hasMetadata = activeKoneData["Metadata"]?.[page] && Object.keys(activeKoneData["Metadata"][page]).length > 0;

                preview[page] = renderPreviewImage(page, template, page, handlePreviewImageClick);
            }

            setTemplateCache(temp);
            setPreviewCache(preview);
        }
    }, [templateUrls, activeKoneData, onDocumentLoad]);

    /**
     * Based on the active page update the active page pdf url to render the pdf page
     */
    useEffect(() => {
        if (pageFileLink !== "") {
            setActivePdfPageUrl(`${pageFileLink}${activePage}/`)
        }
        setInputPage(activePage)
        setIsPageLoading(true) // Show loader when page changes
        setOnDocumentLoad(false) // Reset document load state
    }, [activePage])

    /**
     * Reset functionality to reset states after modal is closed tostreamline the functionality for next action
     */
    const resetState = () => {
        // console.log("RESET STATE IS BEING CALLED!")
        setActiveKone()
        setActiveKoneData({
            "FileName": { "url": "./TEMPLATE.pdf" },
            "TemplateUrls": "./tempk1.png",
            "AfterVerified": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "FinalEngine": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "Metadata": {
                "Page 1": {
                    "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 2": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 3": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 4": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 5": { "Checkbox Coordinates": {}, "Text Coordinates": {} }
                }
            },
            "K1TemplateIds": []
        });
        setTemplateUrls({ "Page 1": "" })
        setMetaData({});
        setFormResponseDataId(undefined)
        setActivePage(1)
        setInputPage(1)
        setValidationStatus(undefined)
        setSaveApiResponse(undefined)
        setApproveApiResponse(undefined)
        setValidationApiResponse(undefined)
        setIsPageLoading(true)
        setOnDocumentLoad(false)
        removeCachedPages()
    }

    /**
     * Fetch and update the data for selected K-1 using the K-1 File ID
     * @param {*} fileId : K-1 ID to fetch data 
     */
    const getActiveKoneData = async (fileId) => {
        if (fileId !== undefined) {
            const data = await makeCygnusApiCall({
                type: "GET",
                payload: {},
                url: `/data/${fileId}/`,
                show_message: false,
                customized_failure_message: "Unable to fetch your data, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while getting the data for this file, please contact support and attach a screenshot.",
                isblob: false,
                path: "/tax",
                istax: true
            })
            setActiveKoneData(data.data[0])
        } else {
            CustomToaster({ type: "error", customized_message: "Unable to read the K-1 ID, please try again." })
        }
    };

    /**
     * This function is used to remove complete page wise data that is cached during comparison until the user saves the draft or approves the response
     */
    const removeCachedPages = () => {
        for (let page of Object.keys(allKoneFields)) {
            localStorage.removeItem(page)
        }
    }

    /**
     * This function is used to update the state of Fields Mapper and cache the individual page changes
     * @param {*} page : The active page of K-1
     * @param {*} id : Field ID that was updated
     * @param {*} map : Field map
     */
    const updateFields = (page, id, map) => {
        if (id !== undefined) {
            setAllKoneFields(akf => (
                {
                    ...akf, [page]: {
                        "K1TemplateId": id,
                        "result": map
                    }
                }))
            setToLS(page, {
                [page]: {
                    "K1TemplateId": id,
                    "result": map
                }
            })
        }
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const updateDataFinal = async () => {
        setSaveApiResponse(true)
        const afterverified = {}
        for (let [page, data] of Object.entries(allKoneFields)) {
            if (Object.keys(data).length > 0) {
                Object.assign(afterverified, {
                    [page]: data
                })
            } else {
                if (activeKoneData["FinalEngine"][page] !== undefined) {
                    Object.assign(afterverified, {
                        [page]: activeKoneData["FinalEngine"][page]
                    })
                } else {
                    Object.assign(afterverified, {
                        [page]: {}
                    })
                }

            }
        }
        let payloadformat = {
            "FormResponseDataId": formResponseDataId,
            "FinalEngine": afterverified,
            "Metadata": activeKoneData["Metadata"]
        }

        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/data/${formResponseDataId}/`,
            show_message: true,
            customized_success_message: "The data was saved successfully.",
            customized_failure_message: "Unable to save your data, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving your data, please contact support and attach a screenshot.",
            isblob: false,
            path: "/tax",
            istax: true
        })
        setSaveApiResponse(false)
        if (data.success == true) {
            onHide()
            props.refresh()
        }
    }


    /**
     * Approve the response after saving
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const ApproveData = async (fileId) => {
        setApproveApiResponse(true)
        let payloadformat = {
            "FormResponseDataId": activeKoneData["FormResponseDataId"],
        }
        // Response is inconsequential
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/data/${fileId}`,
            show_message: true,
            customized_success_message: "Your data is now approved.",
            customized_failure_message: "Unable to approve your data, try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while approving your data, please contact support and attach a screenshot.",
            isblob: false,
            path: "/tax",
            istax: true
        })
        setApproveApiResponse(false)
        if (data.success == true) {
            onHide()
            props.refresh()
        }
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const updateDataDraft = async () => {
        setDraftUpdateApiProgress(true)
        const finalEngine = {}
        for (let [page, data] of Object.entries(allKoneFields)) {
            if (Object.keys(data).length > 0) {
                Object.assign(finalEngine, {
                    [page]: data
                })
            } else {
                if (activeKoneData["FinalEngine"][page] !== undefined) {
                    Object.assign(finalEngine, {
                        [page]: activeKoneData["FinalEngine"][page]
                    })
                } else {
                    Object.assign(finalEngine, {
                        [page]: {}
                    })
                }

            }
        }
        const payloadformat = {
            "FormResponseDataId": formResponseDataId,
            "FinalEngine": finalEngine,
            "Metadata": activeKoneData["Metadata"]
        }
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/data/draft/${formResponseDataId}/`,
            show_message: true,
            customized_success_message: "A draft of your data is now saved.",
            customized_failure_message: "Unable to save your response, try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving your data, please contact support and attach a screenshot.",
            isblob: false,
            path: "/tax",
            istax: true
        })
        setDraftUpdateApiProgress(false)
        if (data.success == true) {
            onHide()
            props.refresh()
        }
    }

    /**
     * This a navigator function to update the active K-1 page to next page
     */
    const previousPage = () => {
        if (parseInt(activePage) > 1) {
            if (parseInt(activePage) <= parseInt(k1TotalPages)) {
                setActivePage(parseInt(activePage) - 1)
            } else {
                setActivePage(1)
            }
        }
    }
    /**
     * This a navigator function to update the active K-1 page to previous page
     */
    const nextPage = () => {
        console.log("Active page: and total pages", activePage, k1TotalPages)
        if (parseInt(activePage) < parseInt(k1TotalPages)) {
            if (parseInt(activePage) >= 1) {
                setActivePage(parseInt(activePage) + 1)
            } else {
                setActivePage(parseInt(k1TotalPages))
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            // alert(e.key)
            if (e.key === "ArrowRight") {
                nextPage();
            }
            if (e.key === "ArrowLeft") {
                previousPage();
            }
            if (e.ctrlKey && e.key.toLowerCase() === "a") {
                e.preventDefault(); // Optional: prevent default "Select All" behavior
                setApproveModal(true);
            }
            if (e.ctrlKey && e.key.toLowerCase() === "s") {
                e.preventDefault(); // Optional: prevent default "Select All" behavior
                updateDataDraft();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [activePage]); // You can include other dependencies if needed

    /**
     * Capture the page input field value on enter to update the active page of K-1
     * @param {*} e : On enter event 
     */
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // if the pressed key is Enter, do something with the value
            setActivePage(e.target.value)
        }
    };

    /**
     * This function just recalls the fetch all K-1 API for refreshing the grid content
     */
    const refreshGrid = () => {
        getActiveKoneData(formResponseDataId)
    }

    // Page-level loader overlay
    const PageLoader = () => (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            backdropFilter: 'blur(2px)'
        }}>
            <Bars
                height="80"
                width="80"
                color="var(--theme1_primary)"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
            <h6 style={{ marginTop: '20px', fontWeight: '500' }}>Loading document...</h6>
        </div>
    );

    return (
        <>
            <ApproveModal
                show={approveModal}
                submit={() => updateDataFinal()}
                approvedata={() => {}}
                validationstatus={validationStatus}
                validationerrorfields={validationErrorFields}
                validationissues={validationIssues}
                saveapiprogress={saveApiResponse}
                validationapiprogress={validationApiResponse}
                approveapiprogress={approveApiResponse}
                onHide={() => setApproveModal(false)}
            />

            <Modal
                {...props}
                onHide={() => {
                    // This will close the modal
                    onHide();
                    // This will reset the state when the modal is closed
                    resetState();
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                backdropClassName="custom-backdrop"
                centered
                className="full-modal"
                scrollable="false"
            >
                <Modal.Header className="mapping-modal-header" style={{ padding: "0px " }} closeButton>
                    <Navbar collapseOnSelect expand="lg" className="sticky-nav kone-nav">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto"></Nav>
                            <Row className="no-gutter flex-row-space-center" style={{ width: "100%" }}>
                                <Col md={4} className="flex-row-center-start pagey nav-buttons">
                                    <Icon.ChevronDoubleLeft className="k1-page-navigation-btns" style={{ margin: "0px 10px 0px 0px" }} onClick={() => setActivePage(1)} />
                                    <Icon.ChevronLeft className="k1-page-navigation-btns" style={{ margin: "0px 15px 0px 0px" }} onClick={() => previousPage()} />
                                    <div className="no-gutter flex-row-space-center">
                                        Page
                                        <input type="number"
                                            className="form-control move-left custom-input" placeholder={activePage}
                                            value={inputPage}
                                            onChange={event => setInputPage(event.target.value)}
                                            onKeyDown={event => handleKeyDown(event)}
                                            autoComplete="new-password"
                                            style={{ width: 25, padding: "0px 5px", margin: "0px 5px", MozAppearance: "textfield" }}
                                        />
                                        of {k1TotalPages}
                                    </div>
                                    <Icon.ChevronRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 15px" }} onClick={() => nextPage()} />
                                    <Icon.ChevronDoubleRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 10px" }} onClick={() => setActivePage(k1TotalPages)} />
                                </Col>
                                <Col md={4} className="flex-row-center-center pagey">
                                    <CustomButton
                                        progress={draftUpdateApiProgress}
                                        onclick={() => updateDataDraft()}
                                        content={draftUpdateApiProgress ? "Saving draft" : "Save draft (Ctrl+S)"}
                                        disable={false}
                                    />
                                    <CustomButton
                                        progress={approveApiResponse}
                                        onclick={() => setApproveModal(true)}
                                        content={approveApiResponse ? "Approving" : "Approve (Ctrl+A)"}
                                        disable={false}
                                    />
                                    <OverlayTrigger
                                        trigger={"click"}
                                        placement="bottom"
                                        delay={{ show: 0, hide: 100 }}
                                        overlay={
                                            <Popover id="button-tooltip">
                                                <Popover.Header as="h6">
                                                    Extracted copy data legend
                                                </Popover.Header>
                                                <Popover.Body>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        padding: '5px',
                                                        borderRadius: '5px',
                                                    }}>
                                                        {LEGEND_DATA.map((item, index) => (
                                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                                <div style={{ backgroundColor: item.color, width: '20px', height: '20px', marginRight: '10px', borderRadius: '3px' }}></div>
                                                                <span style={{ fontSize: '12px', color: '#333' }}>{item.label}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                        error={true}
                                    >
                                        <Icon.PatchQuestionFill style={{ fontSize: 15, color: 'var(--theme1_primary)', marginLeft: 10, cursor: "pointer" }} />
                                    </OverlayTrigger>
                                </Col>
                                <Col md={4} className="flex-row-center-end pagey">
                                    <b>{activeKoneData["FileName"]["placeholder"]}</b>
                                </Col>
                            </Row>
                        </Navbar.Collapse>
                    </Navbar>
                </Modal.Header>
                <Modal.Body className="admin-modal" style={{ paddingTop: "0px", position: 'relative' }}>
                    {/* Page-level loader */}
                    {isPageLoading && <PageLoader />}
                    
                    {/* Main content container - always rendered but with conditional visibility */}
                    <Row className='no-gutter' style={{ 
                        height: "90vh", 
                        opacity: isPageLoading ? 0 : 1,
                        transition: 'opacity 0.2s ease-in-out',
                        pointerEvents: isPageLoading ? 'none' : 'auto'
                    }}>
                        <Col md={1} style={{ padding: 0, margin: 0, overflowY: "scroll", marginTop: "1.4%" }}>
                            {
                                Object.entries(previewCache).map(([page, img], index) =>
                                    <Row key={page} className="flex-row-center-center" style={{ margin: "5px 0px", cursor: "pointer" }} onClick={() => setActivePage(parseInt(page.split(" ")[1]))}>
                                        {img}
                                    </Row>
                                )
                            }
                        </Col>
                        <Col md={5} style={{ padding: 0, margin: "auto", height: "100%" }} >
                            <Row className='no-gutter' style={{ height: "fit-content", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    <h6 style={{ textAlign: 'center' }}>Original copy</h6>
                                </Col>
                            </Row>
                            <Row className='no-gutter' style={{ height: "97%", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    <div className="left-pdf-wrapper flex-row-start-center" style={{ height: "100%" }}>
                                        {
                                            (activePdfPageUrl === "" || activePdfPageUrl) &&
                                            <div
                                                className="pdf-wrapper"
                                                style={{
                                                    flex: 1,
                                                    overflow: 'hidden',
                                                    height: "100%",
                                                    width: "100%"
                                                }}
                                            >
                                                <ComparisonPDFViewer
                                                    activePdfPageUrl={activePdfPageUrl}
                                                    activePage={activePage}
                                                    onDocumentLoad={() => {
                                                        setOnDocumentLoad(true)
                                                        setShowFields(true);
                                                    }}
                                                    
                                                />
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5} style={{ padding: 0, margin: "auto", height: "100%" }}>
                            <Row style={{ height: "fit-content", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    <h6 style={{ textAlign: 'center' }}>Extracted copy</h6>
                                </Col>
                            </Row>
                            <Row className='no-gutter' style={{ height: "97%", width: "100%" }}>
                                <Col md={12} ref={extractedCopyRef} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    {
                                        Object.keys(metaData).length > 0 && onDocumentLoad ?
                                            <>
                                                {/* Right side content */}
                                                <div className="right-pdf-wrapper flex-row-start-center" style={{ height: "100%", width: "100%", objectFit: "cover" }}>
                                                    <div style={{ height: "100%", width: "100%" }}>
                                                        {
                                                            (templateUrls[`Page ${activePage}`] === "" || templateUrls[`Page ${activePage}`]) ? (
                                                                <div
                                                                    className="pdf-wrapper"
                                                                    style={{
                                                                        flex: 1,
                                                                        overflow: 'hidden',
                                                                        height: "100%",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    <img
                                                                        style={{
                                                                            height: 'inherit',
                                                                            width: 'inherit'
                                                                        }}
                                                                        src={templateUrls[`Page ${activePage}`]}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            ) : (
                                                                templateCache[`Page ${activePage}`]
                                                            )
                                                        }
                                                    </div>
                                                    {showFields &&
                                                        PAGE_FIELD_MAPPER[`Page ${activePage}`]
                                                    }
                                                </div>
                                            </>
                                            :
                                            <>
                                                {
                                                    Object.keys(PAGE_FIELD_MAPPER).length === 0
                                                        ?
                                                        <div style={{ left: "40%", top: "50%", width: "fit-content", position: "relative" }}>
                                                            <h6>Loading extracted copy...</h6>
                                                        </div>
                                                        :
                                                        <div className="flex-row-center-center" style={{ height: "100%" }}>Failed to load the response. Do you want to &nbsp;
                                                            <Button className="custom-button" onClick={() => refreshGrid()} >
                                                                <Icon.ArrowClockwise fill="white" className="refresh-button" /> Retry
                                                            </Button>
                                                        </div>
                                                }
                                            </>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}